import { render, staticRenderFns } from "./PerformanceMyStudies.vue?vue&type=template&id=715eec3d"
import script from "./PerformanceMyStudies.vue?vue&type=script&lang=js"
export * from "./PerformanceMyStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports